export const getInitialState = async () => {
  return {
    currentUser: {},
  };
};
